import { h } from 'vue';

const WRAP = {
  bold: (child) => h('strong', child),
  italic: (child) => h('em', child),
  underline: (child) => h('u', child),
  strike: (child) => h('s', child),
  highlight: (child) => h('mark', { class: 'rounded-sm bg-[#ecd79f]/70 px-0.5 text-inherit' }, child),
};

/** The words of a block with their styles. Built as elements, so stored text can never run as markup. */
export default function InlineText({ nodes }) {
  return (nodes ?? []).map((node) => {
    if (node.type === 'hardBreak') return h('br');
    let out = node.text ?? '';
    for (const mark of node.marks ?? []) {
      if (mark.type === 'link') {
        out = h('a', { href: mark.attrs?.href, target: '_blank', rel: 'noopener noreferrer', class: 'underline decoration-[#a0833c] underline-offset-2' }, out);
      } else if (WRAP[mark.type]) {
        out = WRAP[mark.type](out);
      }
    }
    return out;
  });
}
InlineText.props = ['nodes'];
